import { type DataTableLoadingObject } from '@autone/ui';
import { createColumnHelper } from '@tanstack/react-table';

import { type AssortmentProductItem } from '../../../redux/assortment';
import {
  createFirstSaleDateColumn,
  createLatestSaleDateColumn,
  createProductGroupsColumn,
  createTotalSalesUnitsColumn,
  createTotalSalesValueColumn,
} from '../common-columns';

import { createInitialAllocationColumn } from './columns/initial-allocation.column';
import { createLocationsAssortedColumn } from './columns/locations-assorted.column';
import { createPercLocationsAssortedColumn } from './columns/perc-locations-assorted.column';
import { createProductNameColumn } from './columns/product-name.column';
import { createStoreUnitsColumn } from './columns/store-units.column';
import { createWarehousePendingFromProductionColumn } from './columns/warehouse-pending-from-production.column';
import { createWarehouseUnitsColumn } from './columns/warehouse-units.column';

const columnHelper = createColumnHelper<
  AssortmentProductItem | DataTableLoadingObject
>();

export const productsTableColumnDefs = [
  createProductNameColumn(columnHelper),
  createProductGroupsColumn(columnHelper),
  createLocationsAssortedColumn(columnHelper),
  createPercLocationsAssortedColumn(columnHelper),
  createInitialAllocationColumn(columnHelper),
  createTotalSalesUnitsColumn(columnHelper),
  createTotalSalesValueColumn(columnHelper),
  createFirstSaleDateColumn(columnHelper),
  createLatestSaleDateColumn(columnHelper),
  createStoreUnitsColumn(columnHelper),
  createWarehouseUnitsColumn(columnHelper),
  createWarehousePendingFromProductionColumn(columnHelper),
];
